import { httpGet, httpPost, httpDelete } from "../../utils/httpMethods";
import { SERVER_PATH } from "../restEndpoint";

// Get unified billing information (trial, subscription, card, payment history)
export const getBillingInfo = async (userId) => {
  return await httpGet({
    url: `${SERVER_PATH}/api/billing/${userId}`,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Create checkout session to update payment method
export const createPaymentMethodUpdateSession = async (userId) => {
  return await httpPost({
    url: `${SERVER_PATH}/api/billing/${userId}/payment-method/update`,
    payload: {},
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Verify payment method update after checkout completion
export const verifyPaymentMethodUpdate = async (sessionId, userId = "") => {
  return await httpGet({
    url: `${SERVER_PATH}/api/billing/payment-method/verify?session_id=${sessionId}&user_id=${userId}`,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Add payment method (creates Stripe Checkout Session)
export const addPaymentMethod = async (userId) => {
  return await httpPost({
    url: `${SERVER_PATH}/api/billing/${userId}/payment-method`,
    payload: {},
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Remove payment method (works for both trial and subscription)
export const removePaymentMethod = async (userId) => {
  return await httpDelete({
    url: `${SERVER_PATH}/api/billing/${userId}/payment-method`,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Check if user has cancelled subscription with outstanding balance
export const checkCancelledSubscription = async (userId) => {
  return await httpGet({
    url: `${SERVER_PATH}/api/subscriptions/user/${userId}/check-cancelled`,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Cancel subscription
export const cancelSubscription = async (subscriptionId, reason = "") => {
  return await httpPost({
    url: `${SERVER_PATH}/api/subscriptions/${subscriptionId}/cancel`,
    payload: { reason },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Reactivate cancelled subscription
export const reactivateSubscription = async (subscriptionId) => {
  return await httpPost({
    url: `${SERVER_PATH}/api/subscriptions/${subscriptionId}/reactivate`,
    payload: {},
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Verify reactivation payment after Stripe checkout
export const verifyReactivationPayment = async (sessionId, subscriptionId) => {
  return await httpGet({
    url: `${SERVER_PATH}/api/subscriptions/reactivate/verify?session_id=${sessionId}&subscription_id=${subscriptionId}`,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};
